<template>
  <div class="warehouse-order-article -footer">
    <div class="warehouse-order-article_actions">
      <PartialDeliveryConfirmationDialog v-if="!isOrderCompleted">
        <template #button="{ attrs, on }">
          <div
              v-bind="attrs"
              v-on="on"
              class="complete-button"
              :class="{ '-disabled': !canBeCompleted || !isEdited }"
          >
            (Teil-)Lieferung abschliessen und Einräumliste generieren
          </div>
        </template>
      </PartialDeliveryConfirmationDialog>
    </div>
  </div>
</template>

<script>
import {internalOrderMixin} from "@/mixins/SmartLogistics/ModelC/internalOrder";
import PartialDeliveryConfirmationDialog
  from "@/components/SmartLogistics/Warehouse/Dialogs/PartialDeliveryConfirmationDialog.vue";
import it from "vue2-datepicker/locale/es/it";
import tr from "vue2-datepicker/locale/es/tr";

export default {
  name: 'OrderArticleFooter',
  components: {PartialDeliveryConfirmationDialog},
  mixins: [internalOrderMixin],

  computed: {
    canBeCompleted() {
      return !this.isUpdating && this.order.status !== 'done'
    },

    isEdited() {
      const artikelNrLAGs = this.orderItems.map(i => i.artikelNrLAG)

      const activeArticles = this.currentlyOpenPartialDelivery.items.filter(i => artikelNrLAGs.includes(i.artikelNrLAG) && i.orderedQuantity > 0 && !i.deleted && i.deliveredBefore != i.orderedQuantity )

      if(activeArticles.length === 0) {
        return true
      }

      for(let article of activeArticles) {
        if(article.quantity > 0) return true
      }

      return false
    }
  },
}
</script>